import axios from "axios";

const API_URL = process.env.VUE_APP_API_BASE_URL;

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
  // ⭐️ [중요] Flask 호환을 위한 파라미터 직렬화 설정 추가
  paramsSerializer: (params) => {
    const searchParams = new URLSearchParams();
    for (const key in params) {
      const value = params[key];
      if (Array.isArray(value)) {
        // 배열인 경우 (예: category=[1, 2]) -> category=1&category=2 형태로 변환
        value.forEach((val) => searchParams.append(key, val));
      } else if (value !== null && value !== undefined) {
        // 일반 값인 경우
        searchParams.append(key, value);
      }
    }
    return searchParams.toString();
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default {
  // === 인증 ===
  login(email, password) {
    return apiClient.post("/auth/login", { memail: email, mpasswd: password });
  },

  checkAuth() {
    return apiClient.get("/auth/me");
  },

  register(email, password, nickname) {
    return apiClient.post("/auth/register", {
      memail: email,
      mpasswd: password,
      mnickname: nickname,
    });
  },

  sendVerification(email) {
    return apiClient.post("/auth/send-verification", { email: email });
  },

  verifyCode(email, code) {
    return apiClient.post("/auth/verify-code", { email: email, code: code });
  },

  forgotPassword(email) {
    return apiClient.post("/auth/forgot-password", { email: email });
  },

  // [신규] 여정 초기 데이터 (랜덤 10개) 조회
  getJourneyInit() {
    return apiClient.get("/journey/init");
  },

  getNextJourney(mnindex, keyword) {
    return apiClient.post("/journey/next", { mnindex, keyword });
  },

  // === 마닝 (Mining) ===
  getMinings(params) {
    // 위에서 설정한 paramsSerializer가 자동으로 적용됩니다.
    return apiClient.get("/minings/random", { params: params });
  },

  searchMinings(keyword) {
    return apiClient.get("/minings/search", { params: { keyword: keyword } });
  },

  reportWrongMining(mindex, mnindex, contents) {
    return apiClient.post("/miningwrongs", {
      mindex: mindex,
      mnindex: mnindex,
      mwcontents: contents,
    });
  },

  submitQuizResult(data) {
    return apiClient.post("/quiz/submit", data);
  },

  // ⭐️ [추가] 스피드 퀴즈 결과 제출 (입장료 차감 및 보상 로직이 다름)
  submitSpeedQuizResult(data) {
    return apiClient.post("/quiz/speed/submit", data);
  },

  // ⭐️ [신규] 스크래치 게임 시작 (에너지 10 선 차감)
  startScratchGame() {
    return apiClient.post("/quiz/scratch/start");
  },
  
  // ⭐️ [수정] 스크래치 게임 결과 제출 (보상 지급)
  submitScratchResult(data) {
    return apiClient.post("/quiz/scratch/submit", data);
  },

  
  // ⭐️ [수정] 랭킹 API에 type 추가
  getRankings(period, type = "NORMAL") {
    return apiClient.get("/rankings", { params: { period, type } });
  },
  getMyRanking(mindex, period, type = "NORMAL") {
    return apiClient.get("/rankings/my", { params: { mindex, period, type } });
  },

  // === 즐겨찾기 (Favorites) ===
  getGroupedFavorites(mindex) {
    return apiClient.get(`/favorites/grouped/${mindex}`);
  },

  getUserFavorites(mindex) {
    return apiClient.get(`/favorites/mindex/${mindex}`);
  },

  checkFavorites(mindex, mnindexList) {
    return apiClient.post("/favorites/check", {
      mindex: mindex,
      mnindex_list: mnindexList,
    });
  },

  addFavorite(mindex, mnindex) {
    return apiClient.post("/favorites", { mindex: mindex, mnindex: mnindex });
  },

  deleteFavorite(mindex, mnindex) {
    return apiClient.delete("/favorites", {
      data: { mindex: mindex, mnindex: mnindex },
    });
  },

  // //공방 - 어쩌다 위인전
  // createBiography(data) {
  //   // 백엔드 routes/biography.py의 경로와 일치해야 함
  //   return apiClient.post("/biography/create", data);
  // },

  //공방 - 영혼의 편의점
  createReceipt(data) {
    return apiClient.post("/receipt/create", data);
  },
  //뻔뻔한 위원회
  createAward(data) {
  return apiClient.post("/award/create", data);
  },
  // ⭐️ [신규] 20인의 페르소나
  generatePersonaGame() {
    return apiClient.post("/persona/generate");
  },

// === 추리사건의 전말 ===
  getMysteryScenario(difficulty) {
    return apiClient.get("/mystery/scenario", { params: { difficulty } });
  },
  judgeMysteryQuestion(data) {
    return apiClient.post("/mystery/judge", data);
  },
  
  //침팬지 저장
  submitChimpResult(level, playTime) {
    return apiClient.post("/chimpanzee/record", { level, playTime });
  },
// 수포자 5초 전 기록 저장 및 랭킹 조회
  submitMathGiveUpResult(combo, level) {
    return apiClient.post("/math-give-up/record", { combo, level });
  },
  // === [신규] 아주 쉬운 덧셈, 뺄셈 ===
  saveEasyMathRecord(payload) {
    return apiClient.post("/easy-math/record", payload);
  },
  // ⭐️ [신규 추가] 인증번호를 외우고 싶어 기록 저장 및 랭킹 조회
  submitAuthCodeResult(combo, level) {
    return apiClient.post("/auth-code/record", { combo, level });
  },

// === [수정됨] 시크릿 로또 (AI + 다중 전략 지원) ===
  checkLottoPermission() {
    return apiClient.get("/lotto/check-permission");
  },
  
  analyzeLotto(payload) {
    return apiClient.post("/lotto/analyze", payload);
  },


  // === 기타 (Categories, Ads, Notices, Settings) ===
  getCategories() {
    return apiClient.get("/categories");
  },
  updateNickname(mindex, nickname) {
    return apiClient.put(`/members/${mindex}/nickname`, {
      mnickname: nickname,
    });
  },
  //  [추가] 에너지 이력 조회
  getEnergyHistory(page) {
    return apiClient.get("/energy-history", { params: { page } });
  },
  // [추가] 비밀번호 변경
  updatePassword(mindex, currentPassword, newPassword) {
    return apiClient.put(`/members/${mindex}/password`, {
      current_password: currentPassword,
      new_password: newPassword,
    });
  },
  
  //이거 광고
  getFeaturedContent(type, order = null) {
    const params = { type };
    if (order !== null) {
      params.order = order;
    }
    // 백엔드 app.py에서 바꾼 주소와 일치시킵니다.
    return apiClient.get("/contents/featured", { params });
  },

  getNotices() {
    return apiClient.get("/api/notices");
  },
  getNoticeDetail(noindex) {
    return apiClient.get(`/api/notices/${noindex}`);
  },

  createQna(mindex, contents) {
    return apiClient.post("/qna", { mindex: mindex, qnacontents: contents });
  },

  deactivateMember(mindex) {
    return apiClient.put(`/members/${mindex}/deactivate`);
  },

  // ⭐️ 방문자 통계 전송
  trackVisit() {
    return apiClient.post("/stats/visit");
  },
};
